import css from 'styled-jsx/css'

import { colors, sizes } from '../../theme'
import common from '../../theme/common'


export default css`
  .container {
    ${common.text};

    color: ${colors.pureWhite};
    font-family: 'Open Sans Regular', sans-serif;
    display: flex;
    margin-right: 8rem;
    align-items: center;
  }

  address {
    font-style: normal;
  }

  p {
    margin-bottom: 0.5rem;
  }

  .container p :global(a) {
    display: inline;
  }

  .container :global(a) {
    display: block;
    color: ${colors.pureWhite};
    text-decoration: none;
  }

  .container :global(a):hover {
    text-decoration: underline;
  }

  .container :global(.city) {
    ${common.title};
    text-decoration: none;
    font-family: 'Taviraj-Light', serif;
    font-size: 3.6rem;
    line-height: 6rem;
  }

  .container :global(address a) {
    margin-bottom: 0.5rem;
    font-family: 'Open Sans Regular', sans-serif;
    font-size: 1.6rem;
  }

  .blue :global(.city),
  .blue :global(.email) {
    color: ${colors.pureWhite};
  }

  .pink :global(.city),
  .pink :global(.email) {
    color: ${colors.pureWhite};
  }

  aside {
    margin-left: 2rem;
    height: 100px;
    width: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  aside :global(picture) {
    height: 80px;
    width: 80px;
  }

  aside :global(img) {
  }

  @media screen and (max-width: ${sizes.media.tablet.maxWidth}) {

    .container :global(.city) {
      ${common.small};
      font-family: 'Open sans regular', sans-serif;
      font-weight: bold;
      text-transform: uppercase;
      text-decoration: none;
    }

    .container {
      display: flex;
      align-self: stretch;
      margin-right: 0;
      width: 100%;
      padding-left: 2rem;
      padding-right: 2rem;
      margin-bottom: 2rem;
    }

    .container :global(address) {
      flex: 1;
    }

    .container :global(address a) {
      margin-bottom: 0.5rem;
      font-family: 'Open Sans Regular', sans-serif;
      font-size: 1.4rem;
    }
  }
`
